module.exports = __webpack_public_path__ + "img/icon-sb-mattress-medium-boutique-40.126ef43.svg";